import { z } from 'zod'
import { orderArchiveStatusSchema, serviceOrderBusinessStatusSchema } from '@super-mega/server/contracts/order'
import { DEFAULT_PAGE_SEARCH } from '@/const/list.ts'
import {
  createdAtSearchShape,
  createdAtSortSearchShape,
  creatorMemberSearchShape,
  toSearchArray
} from '@/utils/list-query.ts'
import { toBusinessStatusSearch } from './utils/order-list-search.ts'

export const DEFAULT_ORDER_LIST_SEARCH = { ...DEFAULT_PAGE_SEARCH, archiveStatus: 'unarchived' as const }

const multiIdSearch = z.preprocess(
  toSearchArray,
  z.array(z.coerce.number().int().positive()).min(1).max(100).optional()
)
const multiStatusSearch = z.preprocess(
  toBusinessStatusSearch,
  z.array(serviceOrderBusinessStatusSchema).min(1).max(20).optional()
)

export const orderListSearchSchema = z.object({
  serviceMode: z.enum(['once', 'term']).optional().catch(undefined),
  ...createdAtSearchShape,
  ...createdAtSortSearchShape,
  ...creatorMemberSearchShape,
  current: z.coerce.number().int().min(1).catch(DEFAULT_ORDER_LIST_SEARCH.current),
  pageSize: z.coerce.number().int().min(1).max(100).catch(DEFAULT_ORDER_LIST_SEARCH.pageSize),
  subjectId: multiIdSearch.catch(undefined),
  orderGroupId: z.coerce.number().int().positive().optional().catch(undefined),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  keyword: z.string().trim().max(255).optional().catch(undefined),
  note: z.string().trim().max(255).optional().catch(undefined),
  status: multiStatusSearch.catch(undefined),
  archiveStatus: orderArchiveStatusSchema.catch('unarchived'),
  businessId: multiIdSearch.catch(undefined),
  customerId: multiIdSearch.catch(undefined),
  salespersonId: multiIdSearch.catch(undefined)
})

export type OrderListSearch = z.infer<typeof orderListSearchSchema>

// 返回列表的查询状态随历史条目保存，不写入新建页 URL。
declare module '@tanstack/react-router' {
  interface HistoryState {
    serviceOrderListReturnSearch?: OrderListSearch
  }
}
